// manually edited

// 2022
// rybar - vodnik,
// pekarka - jezibaba,
// otec_s_detmi - certi_rodinka,
// starik - ded_vseved,
// jesterka - drak,
// teenager - hejkal,
// pastevkyne - obryne,
// holcicka - cervena_karkulka,
// duchodkyne - sudicky

export interface ItemsConfig {
  [key: string]: {
    numSounds: number;
    backgroundMusicVolume?: number;
  };
}

export const finalToInitialItemMap: { [key: string]: string } = {
  jelen_c: 'jelen_n',
  medved_c: 'medved_n',
  bobr_c: 'bobr_n',
  veverka_c: 'veverka_n',
  vlk_c: 'vlk_n',
  had_c: 'had_n',
  zaba_c: 'zaba_n',
  divocak_c: 'divocak_n',
  vyr_c: 'vyr_n',
};

export const itemsConfig: ItemsConfig = {
  jelen_n: {
    numSounds: 5,
    //backgroundMusicVolume: 0
  },
  medved_n: {
    numSounds: 5,
  },
  bobr_n: {
    numSounds: 5,
  },
  veverka_n: {
    numSounds: 5,
  },
  vlk_n: {
    numSounds: 5,
  },
  had_n: {
    numSounds: 5,
  },
  zaba_n: {
    numSounds: 5,
  },
  divocak_n: {
    numSounds: 5,
  },
  vyr_n: {
    numSounds: 5,
  },
  jelen_c: {
    numSounds: 5,
  },
  medved_c: {
    numSounds: 5,
  },
  bobr_c: {
    numSounds: 5,
  },
  veverka_c: {
    numSounds: 5,
  },
  vlk_c: {
    numSounds: 5,
  },
  had_c: {
    numSounds: 5,
  },
  zaba_c: {
    numSounds: 5,
  },
  divocak_c: {
    numSounds: 5,
  },
  vyr_c: {
    numSounds: 5,
  },
};
